import { render, staticRenderFns } from "./ProfileSidebarComponent.vue?vue&type=template&id=78e74f91&"
import script from "./ProfileSidebarComponent.vue?vue&type=script&lang=js&"
export * from "./ProfileSidebarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports